// extracted by mini-css-extract-plugin
export default {"container":"NX-z","title":"OX-z","link":"PX-z"};